module.exports = __webpack_public_path__ + "img/v5.ea66330f.png";